import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { QuestionsPopupDialogData } from '../shared-components.model';

@Component({
    selector: 'app-questions-popup',
    templateUrl: './questions-popup.component.html',
    styleUrls: ['./questions-popup.component.scss'],
    standalone: false
})
export class QuestionsPopupComponent {
  questions: any[] = [];
  answers: Record<string, any> = {};

  constructor(public dialogRef: MatDialogRef<QuestionsPopupComponent>,
              private translate: TranslateService,
              @Inject(MAT_DIALOG_DATA) public matData: QuestionsPopupDialogData) {
    this.questions  = matData.question ? [matData] : [];
    this.answers  = matData.answer ? { [matData.question]: matData.answer } : {};
  }

  getLabelOption(option) {
    return option === 'true' ? this.translate.instant('form.yes') : this.translate.instant('form.no');
  }

  changeAnswer(answer: any, knockoutValue: any, questionId: string): void {
    this.answers[questionId] = answer.value;
  }

  get qbeWrongKnockout(): boolean {
    return Object.keys(this.answers).some(questionId => {
      const found = this.questions.find(question => question.questionId === questionId);
      return found && found.value !== this.answers[questionId];
    });
  }

}
